import { timeline } from "@/mocks/guaData";

const colorMap = [
  { dot: "bg-primary-500", ring: "ring-primary-200", chip: "bg-primary-100 text-primary-700" },
  { dot: "bg-accent-500", ring: "ring-accent-200", chip: "bg-accent-100 text-accent-800" },
  { dot: "bg-leaf-500", ring: "ring-leaf-200", chip: "bg-leaf-100 text-leaf-700" },
];

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-28 bg-paper-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-1 text-xs font-semibold tracking-[0.2em] text-primary-600">CASE ARCHIVE</div>
            <h2 className="font-serif text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">
              事件复盘 · 一场刷屏的完整时间线
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-stone-500">
            以「发酵 → 扩散 → 回应 → 分化 → 回落」五个阶段为骨架，按公开信息还原事件的真实走向。
          </p>
        </div>

        <div className="relative mt-9 grid gap-8 lg:grid-cols-2">
          {/* 说明面板 */}
          <div className="lg:sticky lg:top-28 lg:self-start">
            <div className="overflow-hidden rounded-lg border border-paper-200 bg-white">
              <img
                src="https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20vertical%20timeline%20with%20milestone%20dots%20connected%20by%20a%20line%20and%20small%20flag%20markers%20and%20clock%2C%20event%20timeline%20and%20case%20archive%20theme%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20warm%20gold%20palette%2C%20minimal%20clean%20vector%20style%2C%20subtle%20grain&width=720&height=480&seq=tl-panel-10&orientation=squarish"
                alt="事件复盘时间线示意图"
                className="h-52 w-full object-cover"
              />
              <div className="p-5">
                <h3 className="font-serif text-lg font-bold text-stone-900">为什么我们要认真排时间线</h3>
                <p className="mt-2 text-sm leading-relaxed text-stone-600">
                  舆论场的信息往往是碎片且跳动的：先看到结论，再拼回过程。把每个节点按时间放回原位，很多「反转」其实早就埋在细节里。
                </p>
                <ul className="mt-4 space-y-2.5 text-sm text-stone-600">
                  <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-leaf-500" />每个节点都标注公开来源与时间戳</li>
                  <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-leaf-500" />只整理已公开信息，存疑处明示待核实</li>
                  <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-leaf-500" />事件结束后进入「复盘档案」长期留档</li>
                </ul>
                <a
                  href="#story"
                  className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-primary-600"
                >
                  查看更多复盘专题 <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </div>

          {/* 时间线 */}
          <div className="relative">
            <span className="absolute left-[7px] top-2 bottom-2 w-px bg-paper-300 md:left-[15px]" />
            <div className="space-y-4">
              {timeline.map((ev, i) => {
                const c = colorMap[i % colorMap.length];
                return (
                  <div key={ev.phase} className="relative flex gap-4">
                    <span className={`relative z-10 mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full ring-4 ${c.dot} ${c.ring} md:ml-2`} />
                    <div className="flex-1 rounded-lg border border-paper-200 bg-white p-4 transition hover:border-primary-200">
                      <div className="flex flex-wrap items-center justify-between gap-2">
                        <div className="flex items-center gap-2">
                          <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${c.chip}`}>{ev.phase}</span>
                          <span className="text-xs text-stone-400"><i className="ri-time-line mr-1" />{ev.time}</span>
                        </div>
                        <span className={`rounded-full px-2 py-0.5 text-[11px] ${
                          ev.status === "进行中" ? "bg-primary-500 text-white" : ev.status === "预告" ? "bg-accent-100 text-accent-800" : "bg-paper-100 text-stone-500"
                        }`}>
                          {ev.status}
                        </span>
                      </div>
                      <h3 className="mt-2 font-serif text-base font-bold text-stone-900">{ev.title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-stone-600">{ev.summary}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}